// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteClientProfileMutationVariables = Types.Exact<{
  clientProfileID: Types.Scalars['ID']['input'];
}>;


export type DeleteClientProfileMutation = { __typename?: 'Mutation', deleteClientProfile: string };

export const Operations = {
  Mutation: {
    DeleteClientProfile: 'DeleteClientProfile' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DeleteClientProfileDocument = gql`
    mutation DeleteClientProfile($clientProfileID: ID!) {
  deleteClientProfile(id: $clientProfileID)
}
    `;
export type DeleteClientProfileMutationFn = Apollo.MutationFunction<DeleteClientProfileMutation, DeleteClientProfileMutationVariables>;

/**
 * __useDeleteClientProfileMutation__
 *
 * To run a mutation, you first call `useDeleteClientProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientProfileMutation, { data, loading, error }] = useDeleteClientProfileMutation({
 *   variables: {
 *      clientProfileID: // value for 'clientProfileID'
 *   },
 * });
 */
export function useDeleteClientProfileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientProfileMutation, DeleteClientProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientProfileMutation, DeleteClientProfileMutationVariables>(DeleteClientProfileDocument, options);
      }
export type DeleteClientProfileMutationHookResult = ReturnType<typeof useDeleteClientProfileMutation>;
export type DeleteClientProfileMutationResult = Apollo.MutationResult<DeleteClientProfileMutation>;
export type DeleteClientProfileMutationOptions = Apollo.BaseMutationOptions<DeleteClientProfileMutation, DeleteClientProfileMutationVariables>;